// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "portal-261006-1/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};